export default [
    {
        path: 'relatorio-quantitativo-procedimento',
        component: () => import(
            /* webpackChunkName: 'ambulatorio-relatorio-quantitativo-procedimento' */
            '@/views/ambulatorio/relatorio-quantitativo-procedimento/Index'
        ),
        redirect: 'relatorio-quantitativo-procedimento/index',
        children: [
            {
                name: 'ambulatorio-relatorio-quantitativo-procedimento-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'ambulatorio-relatorio-quantitativo-procedimento' */
                    '@/views/ambulatorio/relatorio-quantitativo-procedimento/List.vue'
                ),
            },
        ],
    },
]